export default {
	'accounts-configs': 'Accounts configs',
	'items-configs': 'Items configs'
}